import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Menu } from 'client/semantic-imports'
import { AccountStatus } from 'cat-shared/utils'
import { AppHeader } from 'client/ui-building-blocks'
import { getLocalAuthUser } from 'client/services'

import TopBarAccountDropdown from './top-bar-account-dropdown'

import './top-bar.scss'

type Props = {
  accountStatus: AccountStatus
  getOnClickHandler: (path: string) => () => void
}

const TopBarDesktop = ({ accountStatus, getOnClickHandler }: Props) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const localAuthUser = getLocalAuthUser()

  return (
    <>
      <Menu.Item
        link
        as="h4"
        onClick={getOnClickHandler('/home')}
        active={pathname === '/home'}
      >
        <AppHeader text={t('rootPage.topBar.appName')} color="highlighted" />
      </Menu.Item>
      <Menu.Item onClick={getOnClickHandler('/random')} active={pathname === '/random'}>
        <AppHeader
          text={t('rootPage.topBar.browse.items.random')}
          color="light"
          size="small"
        />
      </Menu.Item>
      <Menu.Item onClick={getOnClickHandler('/browse')} active={pathname === '/browse'}>
        <AppHeader
          text={t('rootPage.topBar.browse.items.all')}
          color="light"
          size="small"
        />
      </Menu.Item>
      <Menu.Item onClick={getOnClickHandler('/create')} active={pathname === '/create'}>
        <AppHeader text={t('rootPage.topBar.creator')} color="light" size="small" />
      </Menu.Item>
      <Menu.Item onClick={getOnClickHandler('/best')} active={pathname === '/best'}>
        <AppHeader text={t('rootPage.topBar.bestOfTheBest')} color="light" size="small" />
      </Menu.Item>
      {localAuthUser.isAdmin === 'true' ? (
        <Menu.Item onClick={getOnClickHandler('/data')} active={pathname === '/data'}>
          <AppHeader text={t('rootPage.topBar.dataManager')} color="light" size="small" />
        </Menu.Item>
      ) : null}
      {process.env.NODE_ENV === 'development' ? (
        <Menu.Item onClick={getOnClickHandler('/ui')} active={pathname === '/ui'}>
          <AppHeader text={t('rootPage.topBar.ui')} color="light" size="small" />
        </Menu.Item>
      ) : null}
      <TopBarAccountDropdown
        accountStatus={accountStatus}
        getOnClickHandler={getOnClickHandler}
      />
    </>
  )
}

export default TopBarDesktop
